import { Component, computed, inject, signal, ChangeDetectionStrategy } from '@angular/core';
import { RouterLink } from '@angular/router';
import { LanguageService } from 'src/app/core/services/language.service';
import { CommonModule } from '@angular/common';
import { Account, AccountService } from 'src/app/core/services/account.service';
import { AuthService } from 'src/app/core/services/auth.service';
import { AccountMenuComponent } from 'src/app/components/account-menu/account-menu.component';
import { SolutionsMenuComponent } from 'src/app/components/solutions-menu/solutions-menu.component';
import { TranslatePipe } from '@ngx-translate/core';
import { MobileAccountMenuComponent } from '../../../components/mobile-account-menu/mobile-account-menu.component';
import { LanguageMenuComponent } from '../../../components/language-menu/language-menu.component';
import { FormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatSelectModule } from '@angular/material/select';

@Component({
  selector: 'emp-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    RouterLink,
    AccountMenuComponent,
    SolutionsMenuComponent,
    CommonModule,
    TranslatePipe,
    MobileAccountMenuComponent,
    LanguageMenuComponent,
    FormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatMenuModule,
    MatSelectModule
  ]
})
export class HeaderComponent {
  private authService = inject(AuthService);
  private accountService = inject(AccountService);
  public languageService = inject(LanguageService);

  public accountSearch = signal('');
  public accounts = this.accountService.accounts;
  public currentAccount = this.accountService.currentAccountId;

  public showAccounts = this.authService.isAdmin();

  public filteredAccounts = computed(() => {
    const searchTerms = this.accountSearch().trim().toLowerCase().split(/\s+/);

    return this.accounts().filter(account => {
      const name = account.name.toLowerCase();
      return searchTerms.every(term => name.includes(term)) || account.id === this.currentAccount();
    });
  });

  public focusAccountSearch(searchInput: HTMLInputElement): void {
    requestAnimationFrame(() => searchInput.focus());
  }

  public onAccountChange(accountId: Account['id']): void {
    this.accountService.setAccount(accountId);
  }
}
